module.exports = __webpack_public_path__ + "static/media/Picture.6c09f950.svg";